// @ts-nocheck

import React, { useRef, useEffect } from 'react';

import usePictureInPicture from '../../hooks/usePictureInPicture';
import { PiPWrap } from '../../styled-components/shared';

type Props = {
  className?: string;
  isExpand: boolean;
};

/**
 * @param {string} className set a custom className and allow styled components to apply CSS styles correctly
 * @param {boolean} isExpand define if the placeholder has a padding-top or not
 * @param {string} matchId
 *
 * @return {Node} The placeholder which holds the match stream or the WTV iframe
 */
const PiPPlaceholder = ({ className, isExpand }: Props) => {
  const ref = useRef(null);
  const { isPipCustomActive, setPlaceholderRef } = usePictureInPicture();

  useEffect(() => {
    if (ref?.current) {
      setPlaceholderRef(ref);
    }
  }, [ref, setPlaceholderRef]);

  return <PiPWrap className={className} ref={ref} $isExpand={isExpand && !isPipCustomActive} />;
};

export default PiPPlaceholder;
